export interface ConfirmModalOptions {
  title?: string;
  danger?: string;
  message?: string;
  confirmLabel?: string;
}

export function showConfirmModal(options: ConfirmModalOptions | string): Promise<boolean> {
  const opts: ConfirmModalOptions =
    typeof options === "string" ? { message: options } : options;

  const confirmLabel = opts.confirmLabel ?? "Confirm";

  const overlay = document.createElement("div");
  overlay.className = "toolkit-confirm-delete-modal__overlay";

  const titleHtml = opts.title
    ? `<h3 class="toolkit-confirm-delete-modal__title">${opts.title}</h3>`
    : "";

  overlay.innerHTML = `
    <div class="toolkit-confirm-delete-modal__dialog" role="alertdialog" aria-modal="true">
      <div class="toolkit-confirm-delete-modal__content">
        <div class="toolkit-confirm-delete-modal__icon toolkit-confirm-delete-modal__icon--warning">
          <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
        ${titleHtml}
        <p class="toolkit-confirm-delete-modal__message"></p>
        <div class="toolkit-confirm-delete-modal__actions">
          <button type="button" class="toolkit-button-component toolkit-button-component--orange">${confirmLabel}</button>
          <button type="button" class="toolkit-button-component toolkit-button-component--blue-stroke">Cancel</button>
        </div>
      </div>
    </div>
  `;

  const msgEl = overlay.querySelector(".toolkit-confirm-delete-modal__message") as HTMLElement;

  if (opts.danger) {
    const span = document.createElement("span");
    span.className = "ag-grid-confirm-message--warning";
    span.textContent = opts.danger;
    msgEl.appendChild(span);
    if (opts.message) {
      msgEl.appendChild(document.createElement("br"));
      msgEl.appendChild(document.createTextNode(opts.message));
    }
  } else if (opts.message) {
    // Legacy plain string: first \n-separated line is red warning, rest are normal
    opts.message.split("\n").forEach((line, i) => {
      if (i > 0) msgEl.appendChild(document.createElement("br"));
      if (i === 0) {
        const span = document.createElement("span");
        span.className = "ag-grid-confirm-message--warning";
        span.textContent = line;
        msgEl.appendChild(span);
      } else {
        msgEl.appendChild(document.createTextNode(line));
      }
    });
  }

  document.body.appendChild(overlay);

  return new Promise<boolean>((resolve) => {
    const close = (result: boolean) => {
      overlay.remove();
      document.removeEventListener("keydown", onEsc);
      resolve(result);
    };

    const onEsc = (e: KeyboardEvent) => { if (e.key === "Escape") close(false); };
    document.addEventListener("keydown", onEsc);
    overlay.addEventListener("click", (e) => { if (e.target === overlay) close(false); });

    overlay.querySelector(".toolkit-button-component--orange")!
      .addEventListener("click", () => close(true));
    overlay.querySelector(".toolkit-button-component--blue-stroke")!
      .addEventListener("click", () => close(false));
  });
}
